import { Client } from "../models/client";
import { httpGet, httpPost } from "./http-client";

const apiUrl = '/api/clients';

export const getClients = () => httpGet<Client[]>(apiUrl);
export const getClient = (id: number) => httpGet<Client>(`${apiUrl}/${id}`);
export const createClient = (client: Client) => httpPost<Client>(`${apiUrl}/createclient`, client);
export const updateClient = (client: Client) => httpPost<Client>(`${apiUrl}/updateclient`, client);
